import React, { useState, useEffect } from "react";
import { Link, useNavigate, Redirect, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import swal from "sweetalert";
import { login } from "../../Redux/Action/LoginAction/loginAction";
import { useDispatch } from "react-redux";
import { setItemLocalStorage } from "../../Utils/localStroge";
import { ANDROID_APP_LINK, BUSINESS_TYPE_SIGN_IN, CUSTOMER_TYPE_SIGN_IN, IOS_APP_LINK, SIGN_UP_TYPE } from "../../Utils/constants";
import EyesOnIcon from "../../assets/images/show.png";
import EyesOffIcon from "../../assets/images/hide.png";
import EmailIcon from "../../assets/images/email.png";
import FbIcon from "../../assets/images/facebook.png";
import GoogleIcon from "../../assets/images/google.png";
import { createUserWithEmailAndPassword, getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { getDatabase, ref, set, update } from "firebase/database";
import { get, onValue, off } from "firebase/database";
import { database } from "../../Utils/firebaseConfig";


import "./login.css";
import ValidatedPhoneInput from "../../Component/ValidatedPhoneInput";
import {
  fbRegister,
  googleRegister,
  loginByPhoneApi,
  resendOtpApi,
} from "../../API/ApiService";
import { handleUuidAfterLogin } from "../../Utils/uuidHandler";
import { loadingAction } from "../../Redux/Action/loadingAction";
// import FacebookLogin from "react-facebook-login";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";

import {
  LOGIN_SUCCESS,
  LOGOUT_DETAILS_SUCCESS,
} from "../../Redux/Action/actionTypes";
import axios from "axios";
import { isPhoneValid, validatePhoneComprehensive } from "../../Utils/helperFunction";

function SignIn() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
   const location = useLocation();
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [phone, setPhone] = useState("");
  const [countryCode, setCountryCode] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [isValidPhone, setPhoneValidation] = useState(true);
  const [phoneError, setPhoneError] = useState("");
  const [currentCountry, setCurrentCountry] = useState(null);
  const [showPhoneValidation, setShowPhoneValidation] = useState(false);
  const [values, setValues] = useState({
    email: "",
    password: "",
  });
  //   const [signupStatus, setSignUpStatus] = useState(1);
  const [checkedVal, setCheckedVal] = useState("Customer");
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const [touched, setTouched] = useState({
    email: false,
    password: false,
  });

  // const isValid = isPhoneValid(phone);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      return "Email is required";
    } else if (!emailRegex.test(email)) {
      return "Please enter a valid email address";
    }
    return "";
  };

  const validatePassword = (password) => {
    if (!password) {
      return "Password is required";
    } else if (password.length < 6) {
      return "Password must be at least 6 characters long";
    }
    return "";
  };

  const handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setValues({
      ...values,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };
  const handleBlur = (e) => {
    const name = e.target.name;

    setTouched({
      ...touched,
      [name]: true,
    });

    // Validate on blur
    if (name === "email") {
      setErrors({
        ...errors,
        email: validateEmail(values.email),
      });
    } else if (name === "password") {
      setErrors({
        ...errors,
        password: validatePassword(values.password),
      });
    }
  };

  const handlePhone = (phone, country, inputvalue) => {
    setPhone(phone);
    setCountryCode("+" + country?.dialCode);
    setCurrentCountry(country);
    
    let mystring = phone.replace("+", "");
    mystring = mystring.replace(country?.dialCode, "");
    setPhoneNumber(mystring);
    
    // Validate phone number with country
    if (phone && country) {
      const validation = validatePhoneComprehensive(phone, country);
      setPhoneValidation(validation.isValid);
      setPhoneError(validation.error || "");
    } else {
      setPhoneValidation(true);
      setPhoneError("");
    }
  };

  function getPrefixedEmail(email) {
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;

    if (env === "preprod") {
      return `preprod_${email}`;
    } else if (env === "staging") {
      return `stag_${email}`;
    } else {
      return email;
    }
  }

  // ======= submit Login request ==============


  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    // Validate all fields
    const emailError = validateEmail(values.email);
    const passwordError = validatePassword(values.password);

    // Set all fields as touched
    setTouched({
      email: true,
      password: true,
    });

    // Update errors
    setErrors({
      email: emailError,
      password: passwordError,
    });

    // If there are errors, stop submission
    if (emailError || passwordError) {
      return;
    }

    let body = JSON.stringify({
      email: values.email,
      password: values.password,
      platform: "web",
      os_version: "0",
      app_version: "v.0.0",
      user_timezone: "GMT+5:30",
    });
    // // console.log("body--", body);
    try {
      const response = await dispatch(login(body));
      // Simple way
      const loginDataSuccess = response;
      if (loginDataSuccess) {
        if (loginDataSuccess?.data.status == 200) {
          if (loginDataSuccess?.data?.user?.is_deleted == 0) {
            const result = loginDataSuccess.data.user;
            setItemLocalStorage(
              "accessToken",
              loginDataSuccess.data.access_token
            );
            if (result.user_state === "0" && result.status == 0) {
              const res = await resendOtpApi();
              const loginDataSuccess = res;
              if (loginDataSuccess) {
                swal({
                  title: "OTP sent!",
                  text: "OTP sent to your email",
                  buttons: false,
                  icon: "success",
                  timer: 3000,
                });
              }
              navigate("/signinotp", { state: { forget_password: 0 } })
            } else {

              setItemLocalStorage(
                "refreshToken",
                loginDataSuccess.data.refresh_token
              );
              setItemLocalStorage("user_uuid", result?.user_uuid);
              setItemLocalStorage("id", result?.userProfile?.id);
              setItemLocalStorage("user", JSON.stringify(result));
              setItemLocalStorage('sign_in_type', checkedVal)
              // Handle UUID encoding and API call for both Customer and Business
              if (result?.user_uuid) {
                await handleUuidAfterLogin(result.user_uuid, result);
              }
              loginusingFirebase(result)
              if (result.user_state === "0") {
                navigate("/register");
              } else if (
                (result.user_state === "1" || result.user_state === "2") &&
                checkedVal === "Business"
              ) {
                navigate("/adbusinessdetails");
              } else {
                navigate(location?.state?.backRoute || "/")
              }
            }
          } else {
            swal({
              title: "Inactive User!",
              text: "User is either Inactive or Deleted",
              buttons: false,
              icon: "error",
              timer: 3000,
            });
          }
        } else {
          swal({
            title: "error!",
            text: "Please complete your business details from the mobile app and try again",
            buttons: false,
            icon: "error",
            timer: 3000,
          });
        }
      } else {
        swal({
          title: "error!",
          text: loginDataSuccess?.data?.message,
          buttons: false,
          icon: "error",
          timer: 3000,
        });
      }
    } catch (err) {
      // console.log(err);
    }
  };

  // =============== Send OTP to Phone for customer=====================
  const handleSendPasscode = async () => {
    // Show validation errors when user clicks Send Passcode
    setShowPhoneValidation(true);
    
    // Validate phone with current country
    if (!phone || !currentCountry) {
      setPhoneError("Please enter a valid phone number");
      setPhoneValidation(false);
      return;
    }
    
    const validation = validatePhoneComprehensive(phone, currentCountry);
    if (!validation.isValid) {
      setPhoneValidation(false);
      setPhoneError(validation.error);
      return;
    }
    
    setPhoneValidation(true);
    setPhoneError("");
    dispatch(loadingAction(true));

    let body = JSON.stringify({
      role_id: checkedVal === CUSTOMER_TYPE_SIGN_IN ? 3 : 2,
      country_code: countryCode,
      phone: phoneNumber,
      platform: "web",
      os_version: "0",
      app_version: "v.0.0",
      user_timezone: "GMT+5:30",
    });
    try {
      const response = await loginByPhoneApi(body);
      const loginDataSuccess = response;
      if (loginDataSuccess) {
        dispatch(loadingAction(false));

        const loginData = loginDataSuccess?.data?.user || loginDataSuccess?.data?.result

        if (loginData.is_deleted == 0) {
          setItemLocalStorage(
            "accessToken",
            loginDataSuccess.data.access_token
          );
          setItemLocalStorage('sign_in_type', checkedVal)
          swal({
            title: "OTP Sent successfully!",
            text: "verify OTP send to your Phone",
            buttons: false,
            icon: "success",
            timer: 3000,
          }).then(() =>
            navigate("/signinotp", {
              state: { forget_password: 0, customer_login: true },
            })
          );
        } else {
          swal({
            title: "Inactive User!",
            text: "User is either Inactive or Deleted",
            buttons: false,
            icon: "error",
            timer: 3000,
          });
        }
      } else {
        dispatch(loadingAction(false));

        swal({
          title: "Error!",
          text: loginDataSuccess?.data?.message,
          buttons: false,
          icon: "error",
          timer: 3000,
        });
      }
    } catch (err) {
      dispatch(loadingAction(false));
    }
  };

  const togglePasswordVisibility = (val) => {
    setShowPassword(!showPassword);
  };

  const checkHandler = (event) => {
    setCheckedVal(event.target.value);
  };

  const responseFacebook = async (response) => {
    if (response?.status !== "unknown" || response != "undefined") {
      dispatch(loadingAction(true));
      let body = {
        role_id: checkedVal === CUSTOMER_TYPE_SIGN_IN ? 3 : 2,
        name: response?.name,
        facebook_id: response?.id,
        platform: "web",
        os_version: "0",
        app_version: "v.0.0",
        user_timezone: "GMT+5:30",
      };
      try {
        const responseData = await fbRegister(body);
        const loginDataSuccess = responseData;
        if (loginDataSuccess) {
          dispatch(loadingAction(false));

          if (loginDataSuccess?.data?.result?.is_deleted == 0) {
            setItemLocalStorage(
              "accessToken",
              loginDataSuccess.data.access_token
            );
            setItemLocalStorage(
              "refreshToken",
              loginDataSuccess.data.refresh_token
            );
            setItemLocalStorage(
              "user",
              JSON.stringify(loginDataSuccess.data.result)
            );
            setItemLocalStorage("user_uuid", loginDataSuccess?.data?.result?.user_uuid);
            
            // Handle UUID encoding and API call
            if (loginDataSuccess?.data?.result?.user_uuid) {
              await handleUuidAfterLogin(loginDataSuccess.data.result.user_uuid, loginDataSuccess.data.result);
            }
            
            swal({
              title: "Facebook login successfull!",
              text: " Facebook login successfull",
              buttons: false,
              icon: "success",
              timer: 3000,
            }).then(() => {
              dispatch(loadingAction(false));
              dispatch({ type: LOGOUT_DETAILS_SUCCESS, payload: {} });
              dispatch({ type: LOGIN_SUCCESS, payload: loginDataSuccess });
              navigate("/");
            });
          }
        } else {
          dispatch(loadingAction(false));

          swal({
            title: "Error!",
            text: loginDataSuccess?.data?.message,
            buttons: false,
            icon: "error",
            timer: 3000,
          });
        }
      } catch (err) {
        dispatch(loadingAction(false));
      }
    } else {
      swal({
        title: "Error!",
        text: "Login Failed",
        buttons: false,
        icon: "error",
        timer: 3000,
      });
    }
  };

  const [user, setUser] = useState([]);
  const [profile, setProfile] = useState([]);

  const responseGoogle = useGoogleLogin({
    onSuccess: (CodeResponse) => {
      setUser(CodeResponse);
    },
    // flow: "auth-code",
  });


   const loginusingFirebase = async (userDetails) => {
      const auth = getAuth();
      const db = getDatabase();
      const userEmail = getPrefixedEmail(userDetails.email_id);
      try {
        const password = userDetails?.phone
        try {
          const userCredential = await signInWithEmailAndPassword(
            auth, 
            userEmail,
            password
          );
          
          const user = userCredential.user;
          const userRef = ref(db, `users/${user.uid}`);
          await update(userRef, {
            fcm_token: user?.accessToken || '',
            id: user.uid,
            name: userDetails?.userProfile?.name || '',
            profile_image: userDetails?.userProfile?.profile_image || '',
            user_uuid: userDetails?.user_uuid || '',
          });
            if (userDetails?.user_uuid) {
              try {
                const usersRef = ref(database, "users");
                const snapshot = await get(usersRef);
                if (snapshot.exists()) {
                  let foundUserId = null;
                  snapshot.forEach((child) => {
                    const userData = child.val();
                    if (userData.user_uuid && userData.user_uuid === userDetails.user_uuid) {
                      foundUserId = child.key;
                       const userChatsRef = ref(database, `users/${foundUserId}/chats`);
                        const unsubscribe = onValue(userChatsRef, (snapshot) => {
                          let totalUnread = 0;
                          const chats = snapshot.val();
                          
                          if (chats) {
                            Object.values(chats).forEach(chat => {
                              totalUnread += chat.unreadCount || 0;
                            });
                          }
                          localStorage.setItem("totalUnreadCount", totalUnread);
                        });
    
                        return () => {
                          off(userChatsRef);
                        };
                    }
                  })
                  if (!foundUserId) {
                    console.warn("No user found with user_uuid:", userDetails.user_uuid);
                  }
                } else {
                  // console.log("No users found in database");
                }
              } catch (error) {
                console.error("Error fetching user ID:", error);
              }
            }
        } catch (error) {
          console.error("Sign-in error:", error.code, error.message);
          
          if (error.code === "auth/user-not-found" || error.code === "auth/too-many-requests") {
  
            const userEmail = getPrefixedEmail(userDetails.email_id);
  
            console.log("Creating new user with email:", userEmail);
  
            const newUserCredential = await createUserWithEmailAndPassword(
              auth, 
              userEmail,
              password
            );
            const newUser = newUserCredential.user;
            const userRef = ref(db, `users/${newUser.uid}`);
            await set(userRef, {
              fcm_token: userDetails?.fcm_token || '',
              id: newUser.uid,
              name: userDetails?.userProfile?.name || '',
              profile_image: userDetails?.userProfile?.profile_image || '',
              user_uuid: userDetails?.user_uuid || '',
            });
            
          } else if (error.code === "auth/email-already-in-use") {
            console.error("Email already in use");
          } else if (error.code === "auth/invalid-email") {
            console.error("Invalid email format");
          }
        }
      } catch (error) {
        console.error("Firebase error:", error);
      }
    };
  useEffect(() => {
    if (user?.access_token) {
      axios
        .get(
          `https://www.googleapis.com/oauth2/v2/userinfo?access_token=${user.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${user.access_token}`,
              Accept: "application/json",
            },
          }
        )
        .then((res) => {
          setProfile(res.data);
        })
        .catch((err) => console.log(err));
    }
  }, [user?.access_token]);

  const GoogleRegister = async () => {
    dispatch(loadingAction(true));
    let body = {
      role_id: checkedVal === CUSTOMER_TYPE_SIGN_IN ? 3 : 2,
      name: profile.name,
      email: profile.email,
      platform: "web",
      os_version: "0",
      app_version: "v.0.0",
      user_timezone: "GMT+5:30",
      google_token: user?.access_token,
    };
    try {
      const responseData = await googleRegister(body);
      const loginDataSuccess = responseData;
      // console.log("loginDataSuccess", loginDataSuccess);
      if (loginDataSuccess) {
        dispatch(loadingAction(false));

        if (loginDataSuccess?.data?.result?.is_deleted == 0) {
          setItemLocalStorage(
            "accessToken",
            loginDataSuccess.data.access_token
          );
          setItemLocalStorage(
            "refreshToken",
            loginDataSuccess.data.refresh_token
          );
          setItemLocalStorage(
            "user_uuid",
            loginDataSuccess.data.result.user_uuid
          );
          setItemLocalStorage("id", loginDataSuccess.data.result?.userProfile?.id);
          setItemLocalStorage(
            "user",
            JSON.stringify(loginDataSuccess.data.result)
          );
          setItemLocalStorage('sign_in_type', checkedVal)
          
          // Handle UUID encoding and API call
          if (loginDataSuccess.data.result.user_uuid) {
            await handleUuidAfterLogin(loginDataSuccess.data.result.user_uuid, loginDataSuccess.data.result);
          }
          
          // const auth = getAuth();
        //   const credential = GoogleAuthProvider.credential(null, user.access_token);
        //   signInWithCredential(auth, credential)
        //     .then((firebaseUser) => {
        //   const db = getDatabase();
        //   const userRef = ref(db, `users/${firebaseUser.user.uid}`);
        //   // console.log('userRef', userRef,firebaseUser);
        //   set(userRef, {
        //     fcm_token: firebaseUser.user?.accessToken || '',
        //     id: firebaseUser.user.uid,
        //     name: firebaseUser.user.displayName || '',
        //     profile_image: firebaseUser.user.photoURL || '',
        //     user_uuid: loginDataSuccess.data.result.user_uuid || '',
        //   }).then(() => {
        //     // console.log('User data saved to Firebase Realtime Database');
        //   }).catch((error) => {
        //     console.error('Error saving user data:', error);
        //   });
        //   // console.log('Firebase sign-in successful:', firebaseUser);
        // })
        // .catch((error) => {
        //   console.error('Firebase sign-in error:', error);
        // });
          swal({
            title: "Google login successfull!",
            text: " Google login successfull",
            buttons: false,
            icon: "success",
            timer: 3000,
          }).then(() => {
            const { result } = loginDataSuccess.data
            dispatch(loadingAction(false));
            dispatch({ type: LOGOUT_DETAILS_SUCCESS, payload: {} });
            dispatch({ type: LOGIN_SUCCESS, payload: loginDataSuccess });
            if (result.user_state === "0") {
              navigate("/register");
            } else if ((result.user_state === "1" || result.user_state === "2") && checkedVal === BUSINESS_TYPE_SIGN_IN) {
              navigate("/adbusinessdetails");
            } else {
              navigate("/");
            }
          });
        } else {
          swal({
            title: "Inactive User!",
            text: "User is either Inactive or Deleted",
            buttons: false,
            icon: "error",
            timer: 3000,
          });
        }
      } else {
        dispatch(loadingAction(false));

        swal({
          title: "Error!",
          text: loginDataSuccess?.data?.message,
          buttons: false,
          icon: "error",
          timer: 3000,
        });
      }
    } catch (err) {
      dispatch(loadingAction(false));
    }
  };

  useEffect(() => {
    if (profile && user?.access_token) {
      GoogleRegister();
    }
  }, [profile]);

  return (
    <>
      <div className="container login2 ">
        <div className="row">
          <div className="col-md-6 trust_sec">
            <h1>
              Your Trusted
              <br />
              Local Connection
              <br />{" "}
              <label
                style={{
                  color: "#349c52",
                  position: "relative",
                }}
              >
                Starts Here
                <img
                  src="images/green-suf.png"
                  className="key_feature_designg2"
                  alt=""
                  style={{ left: "3px" }}
                />
              </label>
            </h1>
            <div id="download_app">
              <div className="container login_download_app mt-1">
                <h6>
                  <img
                    src="images/suffixes3.svg"
                    className="suffixes3"
                    alt=""
                  />
                  Please Download and Install Brigiz App
                  <br />
                  to Explore More features{" "}
                  <img
                    src="images/green-suf2.png"
                    className="green-suf2"
                    style={{
                      width: "141px",
                      height: "32px",
                      marginLeft: "-136px",
                    }}
                    alt=""
                  />
                </h6>
              </div>
              <div className=" exp-download-btns mt-4">
                <button
                  onClick={() => window.open(ANDROID_APP_LINK, "_")}
                  style={{ background: "#292828" }}
                >
                  <div className="g_pay_container ">
                    <div className=" btn-img1">
                      <img src="images/play-button.svg" alt="" />
                    </div>
                    <div className=" btn-txt1">
                      <span>GET IT ON</span>
                      <p className="text-white m-0">Google Play</p>
                    </div>
                  </div>
                </button>
                <button
                  onClick={() => window.open(IOS_APP_LINK, "_")}
                  style={{ width: "180px", background: "#292828" }}
                >
                  <div className="g_pay_container">
                    <div className=" btn-img1">
                      <img src="images/apple.svg" />
                    </div>
                    <div className="col-md-9 btn-txt1">
                      <span>Download on the</span>
                      <p className="text-white m-0">App Store</p>
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>

          <div className="col-md-6 form_screen" id="signup_screen_2">
            <div className="login_card bg-white p-5 mt-4 mb-5">
              <div className="login_back_btn">
                {" "}
                <h4 className="login_form_label_2">Welcome Back!</h4>
                <button
                  href="#"
                  style={{ verticalAlign: "text-bottom" }}
                  onClick={() => navigate("/")}
                >
                  <img src="images/back.png" alt="" /> Back
                </button>
              </div>
              <form onSubmit={handleSubmit} className="login_form2">
                <div className="d-flex mt-4 row">
                  <div className="form-check col-md-6">
                    <input
                      type="radio"
                      className="form-check-input"
                      id="radio1"
                      name="optradio"
                      value="Customer"
                      onChange={checkHandler}
                      checked={checkedVal === "Customer"}
                    />
                    <label className="form-check-label2" htmlFor="radio1">
                      For Customer
                    </label>
                  </div>
                  <div className="form-check col-md-6">
                    <input
                      type="radio"
                      className="form-check-input"
                      id="radio2"
                      name="optradio"
                      value="Business"
                      onChange={checkHandler}
                      checked={checkedVal === "Business"}
                    />

                    <label className="form-check-label2" htmlFor="radio2">
                      For Business
                    </label>
                  </div>
                </div>
                {checkedVal === "Customer" ? (
                  <>
                    <label className="login_form_email2 mt-4 mb-2">
                      Mobile Number
                    </label>
                    <ValidatedPhoneInput
                      defaultCountry="us"
                      value={phone}
                      onChange={(phone, { country, inputValue }) => {
                        handlePhone(phone, country, inputValue);
                      }}
                      onValidationChange={(validation) => {
                        setPhoneValidation(validation.isValid);
                        setPhoneError(validation.error || "");
                      }}
                      showValidation={showPhoneValidation}
                      name="phone"
                    />
                    <div className="my-3 text-center">
                      <span
                        className="send_passcode"
                        role="button"
                        onClick={handleSendPasscode}
                      >
                        Send Passcode
                      </span>
                    </div>
                    <div className="or_div my-5">
                      <h6>
                        <span>OR</span>
                      </h6>
                    </div>
                    <div className="login_signup_div">
                      <button onClick={() => navigate("/login", { state: { checkedVal } })}>
                        <img src={EmailIcon} alt="" className="me-3" />
                        Sign In/Sign Up
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <label className="login_form_email2 mt-4 mb-2">
                      Email Address
                    </label>
                    <input
                      className="login_form_input2"
                      type="text"
                      name="email"
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                    />
                    {touched.email && errors.email && (
                      <div
                        className="error-message text-danger "
                        style={{ marginBottom: "14px" }}
                      >
                        {errors.email}
                      </div>
                    )}
                    <label className="login_form_email2 my-2">Password</label>
                    <div className="password-input-container">
                      <input
                        className="login_form_input2"
                        type={showPassword ? "text" : "password"}
                        name="password"
                        onChange={handleInputChange}
                      />
                      <button
                        type="button"
                        className="password-toggle-btn bg-transparent"
                        onClick={togglePasswordVisibility}
                      >
                        {showPassword ? (
                          <img src={EyesOnIcon} className="eyes-icon" alt="" />
                        ) : (
                          <img src={EyesOffIcon} className="eyes-icon" alt="" />
                        )}
                      </button>
                    </div>
                    {errors.password && (
                      <div className="invalid-feedback d-block">
                        {errors.password}
                      </div>
                    )}
                    <div className="forgot_password text-end">
                      <Link to="/forgotpassword">Forgot Password</Link>
                    </div>
                    <button
                      className="login_form_btn mt-4"
                      disabled={!checkedVal}
                    >
                      Sign In
                    </button>
                    <div className="signup_text text-center mt-3">
                      Don’t have an account? <span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => navigate('/register', { state: { checkedVal } })}>Sign Up</span>
                    </div>
                  </>
                )}
                <div className='or_div my-5'>
                  <h6>
                    <span>OR</span>
                  </h6>
                </div>
                {/* <div className='social_login_div my-4'>
                  <FacebookLogin
                    appId='731226891753558'
                    autoLoad={false}
                    fields="name,email,picture"
                    scope="public_profile,email"
                    callback={responseFacebook}
                    render={(renderProps) => (
                      <button type='button' onClick={renderProps.onClick}>
                        <img src={FbIcon} alt='' className='me-3' />
                        Continue with Facebook
                      </button>
                    )}
                    icon={FbIcon}
                  />
                </div> */}
                <div className='social_login_div'>
                  <button onClick={responseGoogle} type='button'>
                    <img src={GoogleIcon} alt='' className='me-3' />
                    Continue with Google
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div id="mobile_view">
          <div className="container login_download_app mt-1">
            <h6>
              <img src="images/suffixes3.svg" className="suffixes3" alt="" />
              Please Download and Install Brigiz App
              <br />
              to Explore More features{" "}
              <img
                src="images/green-suf2.png"
                className="green-suf2"
                style={{
                  width: "168px",
                  height: "32px",
                  marginLeft: "-158px",
                }}
                alt=""
              />
            </h6>
          </div>
          <div className=" exp-download-btns mt-4">
            <button
              onClick={() => window.open(ANDROID_APP_LINK, "_")}
              style={{ background: "#292828" }}
            >
              <div className="g_pay_container ">
                <div className=" btn-img1">
                  <img src="images/play-button.svg" alt="" />
                </div>
                <div className=" btn-txt1">
                  <span>GET IT ON</span>
                  <p className="text-white m-0">Google Play</p>
                </div>
              </div>
            </button>
            <button
              onClick={() => window.open(IOS_APP_LINK, "_")}
              style={{ width: "180px", background: "#292828" }}
            >
              <div className="g_pay_container">
                <div className=" btn-img1">
                  <img src="images/apple.svg" />
                </div>
                <div className="col-md-9 btn-txt1">
                  <span>Download on the</span>
                  <p className="text-white m-0">App Store</p>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default SignIn;
